import React, { useEffect, useState } from 'react';
import axios from '../api/axios';
import { IconCheck, IconTrash } from '../components/Icons';
import '../components/AdminUI.css';

export default function Cities() {
  const [items, setItems] = useState([]);
  const [draft, setDraft] = useState({ name: '', name_ar: '', name_en: '', shipping_price: 0, is_active: true, sort_order: 0 });

  const load = () => axios.get('/cities').then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const save = async (city) => {
    await axios.put(`/cities/${city.id}`, city);
    load();
  };

  const create = async () => {
    await axios.post('/cities', draft);
    setDraft({ name: '', name_ar: '', name_en: '', shipping_price: 0, is_active: true, sort_order: 0 });
    load();
  };

  const remove = async (id) => {
    if (!window.confirm('Supprimer ?')) return;
    await axios.delete(`/cities/${id}`);
    load();
  };

  return (
    <div className="admin-page">
      <div className="admin-card">
        <h3 style={{ marginTop: 0 }}>Ajouter une ville</h3>
        <div className="admin-grid admin-grid-2">
          <div><label className="admin-label">Nom (FR)</label><input className="admin-input" value={draft.name} onChange={(e) => setDraft({ ...draft, name: e.target.value })} /></div>
          <div><label className="admin-label">Nom (AR)</label><input className="admin-input" dir="rtl" value={draft.name_ar} onChange={(e) => setDraft({ ...draft, name_ar: e.target.value })} /></div>
          <div><label className="admin-label">Nom (EN)</label><input className="admin-input" value={draft.name_en} onChange={(e) => setDraft({ ...draft, name_en: e.target.value })} /></div>
          <div><label className="admin-label">Prix livraison (MAD)</label><input className="admin-input" type="number" value={draft.shipping_price} onChange={(e) => setDraft({ ...draft, shipping_price: parseFloat(e.target.value || 0) })} /></div>
        </div>
        <button className="admin-btn admin-btn-gold" onClick={create} style={{ marginTop: 12 }}>Ajouter</button>
      </div>

      <div className="admin-card" style={{ padding: 0, overflow: 'auto' }}>
        <table className="admin-table">
          <thead>
            <tr><th>FR</th><th>AR</th><th>EN</th><th>Prix (MAD)</th><th>Actif</th><th>Ordre</th><th></th></tr>
          </thead>
          <tbody>
            {items.map((c) => (
              <tr key={c.id}>
                <td><input className="admin-input" value={c.name || ''} onChange={(e) => setItems(items.map((x) => x.id === c.id ? { ...x, name: e.target.value } : x))} /></td>
                <td><input className="admin-input" dir="rtl" value={c.name_ar || ''} onChange={(e) => setItems(items.map((x) => x.id === c.id ? { ...x, name_ar: e.target.value } : x))} /></td>
                <td><input className="admin-input" value={c.name_en || ''} onChange={(e) => setItems(items.map((x) => x.id === c.id ? { ...x, name_en: e.target.value } : x))} /></td>
                <td><input className="admin-input" type="number" value={c.shipping_price} onChange={(e) => setItems(items.map((x) => x.id === c.id ? { ...x, shipping_price: parseFloat(e.target.value || 0) } : x))} /></td>
                <td><input type="checkbox" checked={!!c.is_active} onChange={(e) => setItems(items.map((x) => x.id === c.id ? { ...x, is_active: e.target.checked } : x))} /></td>
                <td><input className="admin-input" type="number" value={c.sort_order} onChange={(e) => setItems(items.map((x) => x.id === c.id ? { ...x, sort_order: parseInt(e.target.value || 0) } : x))} /></td>
                <td>
                  <div className="admin-actions">
                    <button className="admin-icon-btn is-success" title="Enregistrer" aria-label="Enregistrer" onClick={() => save(c)}>
                      <IconCheck />
                    </button>
                    <button className="admin-icon-btn is-danger" title="Supprimer" aria-label="Supprimer" onClick={() => remove(c.id)}>
                      <IconTrash />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ fontSize: 13, color: '#64748b', marginTop: 8 }}>
        Astuce : pour activer la livraison gratuite globale, allez dans <strong>Paramètres → Shipping</strong> et cochez <code>free_shipping_enabled</code>.
      </div>
    </div>
  );
}
